import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/user_user",
				name: "user_user",
				component: () => import("../views/hr/user_user.vue"),
			},
			{
				path: "/user_salary",
				name: "user_salary",
				component: () => import("../views/hr/user_salary.vue"),
			},
			{
				path: "/user_entry",
				name: "user_entry",
				component: () => import("../views/hr/user_entry.vue"),
			},
			{
				path: "/user_certificate",
				name: "user_certificate",
				component: () => import("../views/hr/user_certificate.vue"),
			},
			{
				path: "/user_birthday",
				name: "user_birthday",
				component: () => import("../views/hr/user_birthday.vue"),
			},
			{
				path: "/business_checkin",
				name: "business_checkin",
				component: () => import("../views/hr/business_checkin.vue"),
			},
			{
				path: "/business_event",
				name: "business_event",
				component: () => import("../views/hr/business_event.vue"),
			},
			{
				path: "/common_template",
				name: "common_template",
				component: () => import("../views/hr/common_template.vue"),
			},
			{
				path: "/common_calendar",
				name: "common_calendar",
				component: () => import("../views/hr/common_calendar.vue"),
			},
			{
				path: "/common_holiday",
				name: "common_holiday",
				component: () => import("../views/hr/common_holiday.vue"),
			},
			{
				path: "/dict_salary",
				name: "dict_salary",
				component: () => import("../views/hr/dict_salary.vue"),
			},
			{
				path: "/dict_certificate",
				name: "dict_certificate",
				component: () => import("../views/hr/dict_certificate.vue"),
			},
			{
				path: "/dict_event",
				name: "dict_event",
				component: () => import("../views/hr/dict_event.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/hr/config_right.vue"),
			},
			{
				path: "/config_shortcut",
				name: "config_shortcut",
				component: () => import("../views/hr/config_shortcut.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
